import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { execute, gql, type ResultOf } from '~/services-v2/financial-bff/financial-bff-gql'

const GQL = gql(`
  query AvailableOrders(
    $projectId: String!
    $withSummary: Boolean
    $orderId: Int
    $page: Int
    $pageSize: Int
  ) {
    available_orders(
      projectId: $projectId
      with_summary: $withSummary
      order_id: $orderId
      page: $page
      page_size: $pageSize
    ) {
      data {
        order_id
        value
        created_at
        expire_at
        kit {
          id
          order_number
          expires_at
          total_value
          error
        }
      }
      pagination {
        page
        page_size
        total
        has_next
      }
    }
  }
`)

export type AvailableOrdersQuery = ResultOf<typeof GQL>
export type AvailableOrdersData = AvailableOrdersQuery['available_orders']

export default function useAvailableOrders(projectId: Ref<string>) {
  const queryKey = queryKeys.PAYMENT_MODEL.AVAILABLE_ORDERS(projectId.value)

  const queryFn = async () => {
    if (!projectId.value) {
      throw new Error('Project ID is required')
    }

    const res = await execute(GQL, {
      projectId: projectId.value,
      withSummary: true,
    })

    return res.available_orders
  }

  return useQuery({
    queryKey,
    queryFn,
    retry: 3,
    retryDelay: 1000, // 1 second
    enabled: !!projectId.value,
  })
}
